const axios = require('axios');
import $storage from '~/utils/storage/storage.js'
const api = axios.create({})
api.interceptors.response.use(
  async (response) => {
    if (response.status === 200) {
      return await response.data;
    }
  },
  async (error) => {
    const { config, response } = error;
    if (response.status === 500) {
      return {
        error: false,
        config,
        response,
        message: response.data.messages
      };
    } else {
      return {
        error: true,
        status: response.status,
        message: response.data.messages.error || ''
      };
    }
  }
)
api.interceptors.request.use((config) => {
  const { method } = config
  config.baseURL = '/api';
  config.headers.common['X-Requested-With'] = 'XMLHttpRequest';
  config.headers.common['X-CSRF-TOKEN'] = document.querySelector('meta[name="csrf-token"]').content;
  config.headers.Authorization = $storage.get('auth.token.local')

  if (method === 'post') {
    const body = new FormData(),
      args = config.data
    Object.keys(args).filter((r) => {
      body.append(r, args[r])
    })
    if (args.files) {
      Object.keys(args.files).filter((r) => {
        body.append(r, args.files[r])
      })
    }
    config.data = body
  }
  return config
})
api.create = api.post
api.update = api.put
api.upload = api.post

window.axios = api
export default api
